const footerData = () => {
  return [
    {
      title: "Contact",
      url: "/contact",
      index: 0,
    },

    {
      title: "FAQ",
      url: "/faq",
      index: 1,
    },

    {
      title: "CIDC Member",
      url: "/member",
      index: 2,
    },

    {
      title: "Careers",
      url: "/careers",
      index: 3,
    },
    {
      title: "Brokers",
      url: "/brokers",
      index: 4,
    },
  ];
};

export default footerData;
